import React from 'react';

const Logo = ({ size = 'default', className = '', onClick }) => {
  const sizes = {
    small: { container: 'w-6 h-6', text: 'text-base' },
    default: { container: 'w-8 h-8', text: 'text-lg' },
    large: { container: 'w-12 h-12', text: 'text-3xl' }
  };

  const currentSize = sizes[size];

  const logoContent = (
    <>
      <img
        src="/favicon.png"
        alt="Kynaix Sports"
        className={`${currentSize.container} object-contain rounded-xl`}
      />
      <span
        className={`${currentSize.text} font-black tracking-tight`}
        style={{ background: 'linear-gradient(90deg, #2196F3, #9C4DCC, #FF9800)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}
      >
        Kynaix Sports
      </span>
    </>
  );

  if (onClick) {
    return (
      <button
        onClick={onClick}
        className={`flex items-center gap-x-2 hover:opacity-80 transition-opacity ${className}`}
      >
        {logoContent}
      </button>
    );
  }

  return (
    <div className={`flex items-center gap-x-2 ${className}`}>
      {logoContent}
    </div>
  );
};

export default Logo;